import HttpClient from './HttpClient'
import {authService} from '../../'

const entroHttpClient = new HttpClient({
  refreshCookieUrl: `${window.ENTRO_AUTH_URI}/api/refresh-cookie`,
  onInvalidToken: () => {
    authService.redirectToLogin(window.ENTRO_AUTH_URI);
  }
});

const optimaHttpClient = new HttpClient({
  refreshCookieUrl: `${window.OPTIMA_AUTH_URI}/api/refresh-cookie`,
  onInvalidToken: () => {
    authService.redirectToLogin(window.ENTRO_AUTH_URI);
  }
});

const effenHttpClient = new HttpClient({
  refreshCookieUrl: `${window.EFFEN_AUTH_URI}/api/refresh-cookie`,
  onInvalidToken: () => {
    authService.redirectToLogin(window.ENTRO_AUTH_URI);
  }
});

export {
  entroHttpClient,
  optimaHttpClient,
  effenHttpClient
}
